import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageLoader } from '../../layouts/components/PageLoader/PageLoader';
import { routes } from '../routes';
import { useOnboarding } from '@/features/onboarding/hooks/useOnboarding';
import type { UserOnboardingState } from '@/features/onboarding/types/onboarding';
import { useApplication } from '@/features/application/hooks';

export const OnboardingGuard = () => {
  const {
    isApplicationStateLoading
  } = useApplication(true);

  const { onboardingState, isOnboardingStateLoading, isCompleted } =
    useOnboarding(true);

  const location = useLocation();

  if (isOnboardingStateLoading || isApplicationStateLoading) {
    return <PageLoader />;
  }

  if (isCompleted) {
    return <Navigate to={routes.wizard.base} replace />;
  }

  const nextStep = getNextOnboardingStep(onboardingState!);

  if (location.pathname !== nextStep) {
    return <Navigate to={nextStep} replace />;
  }

  return <Outlet />;
};

function getNextOnboardingStep(onboarding: UserOnboardingState) {
  if (!onboarding.isCnpCompleted) return routes.onboarding.cnp;

  return routes.wizard.base;
}
